<template>
    <div class="h-md-100 overflow-y-auto position-relative mt-n4">
        <div class="position-absolute top-0 left-0 me-1 mt-12" v-if="showActions">
            <v-btn @click="$emit('deleted')" class="rounded mx-1" icon="icon-trash" variant="tonal" color="error" v-tooltip="'حذف مشتری'"></v-btn>
            <v-btn @click="$router.push({path: '/tickets',query: {customer_id: user.id.toString()}})" class="rounded mx-1" icon="icon-listticket" variant="tonal" color="secondary" v-tooltip="'لیست تیکت ها'"></v-btn>
            <v-btn v-if="$rbac.can('send ticket to customers')" @click="$router.push({path: '/tickets/new',query: ($auth.user.full_admin) ? {customer_ids: user.id.toString(), branch_id: user.branch_id} : {customer_ids: user.id.toString()} })" class="rounded mx-1" icon="icon-newticket" variant="tonal" color="secondary" v-tooltip="'ارسال تیکت به مشتری'"></v-btn>
            <v-btn v-if="$system.license.features.ticket_send_behalf_customer && $rbac.can('send ticket behalf customers')" @click="$router.push({path: '/tickets/fromCustomer',query: {customer_id: user.id.toString()} })" class="rounded mx-1" icon="icon-comment-user" variant="tonal" color="secondary" v-tooltip="'ارسال تیکت از طرف مشتری'"></v-btn>
            <v-btn v-if="showCall" @click="$emit('called')" class="rounded mx-1" icon="icon-mobile" variant="tonal" color="secondary" v-tooltip="'تماس با مشتری'"></v-btn>
            <v-btn @click="$router.push({path: '/customers/edit',query: {id: user.id}})" class="rounded mx-1" icon="icon-editt" variant="tonal" color="secondary" v-tooltip="'ویرایش مشتری'"></v-btn>
        </div>
        <div class="rounded bg-white px-4" :class="group.image || group.icon ? 'mt-10 pt-5' : 'mt-3'" v-for="group in list">
            <v-avatar size="60" class="helpical-shadow mt-n16 bg-white" v-if="group.image || group.icon">
                <v-img v-if="group.image" :src="group.image"></v-img>
                <v-icon v-if="group.icon" v-tooltip="group.tooltip" :icon="group.icon" size="36" color="secondary"></v-icon>
            </v-avatar>
            <div v-for="(item, index) in group.data" v-if="group.data">
                <div class="d-flex justify-space-between py-2">
                    <p class="text-primary text-small font-weight-bold">{{ item.title }}:</p>
                    <p class="text-grey-darken-2 text-small font-weight-medium">{{ item.value ?? '-------' }}</p>
                </div>
                <v-divider v-if="index != group.data.length - 1"></v-divider>
            </div>
        </div>
    </div>
</template>

<script>
import noUser from '@/assets/img/noUser.png';
export default {
    props: {
        showCall: {
            type: Boolean,
            default: false,
        },
        showActions: {
            type: Boolean,
            default: false,
        },
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        list() {
            return [
                {
                    image: this.showActions ? (this.user.profile_picture_name ? this.user.profile_picture_name : noUser) : null,
                    data: [
                        { title: "نام", value: this.user.first_name },
                        { title: "نام خانوادگی", value: this.user.last_name },
                        { title: "نام کاربری", value: this.user.username },
                        { title: "تاریخ تولد", value: this.user.birthday ? this.$moment(this.user.birthday).format('jYYYY/jMM/jDD') : null },
                        { title: "شماره موبایل", value: this.user.mobile },
                        { title: "شماره تماس ثابت", value: (this.user.landline ?? null) + (this.user.landline && this.user.interphone ? ` (داخلی ${this.user.interphone})` : null) },
                        { title: "سطح مشتری", value: this.$system.customerLevels.find(x => x.id == this.user.customer_information?.customer_level_id)?.name },
                        { title: "ایمیل", value: this.user.email },
                        { title: "استان", value: this.user.customer_information?.state_id && this.$system.states.length ? this.$system.states.find(x => x.id == this.user.customer_information.state_id).name : null },
                        { title: "شهر", value: this.user.customer_information?.city_id && this.$system.cities.length ? this.$system.cities.find(x => x.id == this.user.customer_information.city_id).name : null },
                        { title: "آدرس", value: this.user.address },
                        { title: "توضیحات", value: this.user.customer_information?.description },
                    ]
                },
            ].concat(this.$system.license.features.customer_custom_field && this.user.custom_fields?.length ? [
                {
                    icon: 'icon-customeruser',
                    tooltip: 'فیلد های سفارشی',
                    data: this.user.custom_fields.map(x => Object.assign({}, {title: this.getLabel(x), value: this.getValue(x)}))
                }
            ] : []).concat(this.user?.customer_information?.organization ? [
                {
                    icon: 'icon-orgg',
                    tooltip: 'اطلاعات سازمان',
                    data: [
                        { title: "نام", value: this.user.customer_information.organization.name },
                        { title: "نام سرپرست", value: this.user.customer_information.organization.customer_informations?.length ? this.user.customer_information.organization.customer_informations.map(x => x.user.name).join(', ') : null },
                        { title: "شماره تماس", value: this.user.customer_information.organization.phone },
                        { title: "وبسایت", value: this.user.customer_information.organization.website },
                        { title: "سطح", value: this.$system.customerLevels.find( (x) => x.id == this.user.customer_information.organization.customer_level_id)?.name },
                        { title: "آدرس", value: this.user.customer_information.organization.address },
                        { title: "توضیحات", value: this.user.customer_information.organization.description },
                    ]
                }
            ] : []).concat(this.$system.license.features.organization_custom_field && this.user?.customer_information?.organization?.custom_fields?.length ? [
                {
                    icon: 'icon-customdep',
                    tooltip: 'فیلد های سفارشی سازمان',
                    data: this.user.customer_information.organization.custom_fields.map(x => Object.assign({}, {title: this.getLabel(x), value: this.getValue(x)}))
                }
            ] : []);
        }
    },
    methods: {
        getLabel(item) {
            let label = item.label ?? item.options.label;
            return label.length > 45 ? label.slice(0,45) + '.....' : label;
        },
        getValue(item) {
            if (item.type === "checkbox")
                return item.value == 0 ? 'خیر' : 'بله';
            if (item.type == 'date')
                return item.value ? this.$moment(item.value, 'X').format(item.options.type == 'time' ? 'HH:mm' : item.options.type == 'datetime' ? 'jYYYY-jMM-jDD HH:mm' : 'jYYYY-jMM-jDD') : null;
            return item.value;
        },
    },
    created() {
        this.$system.setStatesCities();
    }
};
</script>
